(function () {
  var STORAGE_KEY = 'bd_recently_viewed';
  var section = document.querySelector('[data-bd-rv-section]');
  if (!section) return;

  var currentHandle = section.getAttribute('data-current-handle');
  var grid = section.querySelector('[data-bd-rv-grid]');
  var maxItems = parseInt(section.getAttribute('data-max-items'), 10) || 6;

  function getViewed() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (err) {
      return [];
    }
  }

  function setViewed(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  /* ---- 1. Track the current product ---- */
  if (currentHandle) {
    var list = getViewed();
    list = list.filter(function (h) { return h !== currentHandle; });
    list.unshift(currentHandle);
    if (list.length > 20) list = list.slice(0, 20);
    setViewed(list);
  }

  /* ---- 2. Render everything EXCEPT the current product ---- */
  var toShow = getViewed()
    .filter(function (h) { return h !== currentHandle; })
    .slice(0, maxItems);

  if (!toShow.length) return;

  function buildCard(p) {
    var variant = p.variants && p.variants[0];
    var price = variant ? variant.price : p.price;
    var image = p.featured_image || (p.images && p.images[0]) || '';

    var a = document.createElement('a');
    a.href = '/products/' + p.handle;
    a.className = 'bd-rv__card';
    a.innerHTML =
      '<div class="bd-rv__card-media">' +
      (image ? '<img src="' + image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="bd-rv__card-info">' +
      '<p class="bd-rv__card-title">' + (p.title || '') + '</p>' +
      '<p class="bd-rv__card-price">' + formatMoney(price) + '</p>' +
      '</div>';
    return a;
  }

  function formatMoney(cents) {
    return '\u20b9' + (cents / 100).toFixed(2);
  }

  Promise.all(
    toShow.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    })
  ).then(function (products) {
    var valid = products.filter(function (p) { return p !== null; });
    if (!valid.length) return;

    valid.forEach(function (p) {
      grid.appendChild(buildCard(p));
    });
    section.hidden = false;
  });
})();